let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9lgXg")).then(() => parcelRequire('bj2br'));